import { useState, useEffect } from 'react';
import QRCode from 'qrcode';

interface QRShareProps {
  numbers: number[];
  bonus: number | null;
  label?: string | null;
  onClose: () => void;
}

export default function QRShare({ numbers, bonus, label, onClose }: QRShareProps) {
  const [qrUrl, setQrUrl] = useState('');
  const [copied, setCopied] = useState(false);

  const text = (() => {
    let t = `로또 6/45 번호\n${numbers.join(', ')}\n`;
    if (bonus !== null) t += `보너스: ${bonus}`;
    if (label) t = `[${label}]\n` + t;
    return t;
  })();

  useEffect(() => {
    QRCode.toDataURL(text, { width: 256, margin: 2, color: { dark: '#333', light: '#fff' } })
      .then((url) => setQrUrl(url))
      .catch(() => setQrUrl(''));
  }, [text]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  };

  const handleDownload = () => {
    if (!qrUrl) return;
    const link = document.createElement('a');
    link.href = qrUrl;
    link.download = `lotto-${numbers.join('-')}.png`;
    link.click();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div className="bg-background-50 rounded-2xl p-6 md:p-8 max-w-sm w-full shadow-lg" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-lg text-foreground-800">번호 공유</h3>
          <button onClick={onClose} className="text-foreground-400 hover:text-foreground-600 cursor-pointer">
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>
        <div className="flex flex-col items-center gap-4">
          {qrUrl ? (
            <img src={qrUrl} alt="QR Code" className="w-56 h-56 rounded-lg" />
          ) : (
            <div className="w-56 h-56 bg-background-100 rounded-lg flex items-center justify-center">
              <div className="w-8 h-8 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
            </div>
          )}
          <p className="text-sm text-foreground-500 text-center whitespace-pre-line">{text}</p>
          <div className="flex gap-2 w-full">
            <button onClick={handleCopy} className="flex-1 py-2.5 rounded-lg bg-secondary-500 hover:bg-secondary-600 text-white text-sm font-medium transition-all cursor-pointer whitespace-nowrap">
              {copied ? '복사 완료!' : '텍스트 복사'}
            </button>
            <button onClick={handleDownload} disabled={!qrUrl} className="flex-1 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-all disabled:opacity-50 cursor-pointer whitespace-nowrap">
              QR 저장
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}